import type { InrixVolumeFeature } from "../models/InrixVolumeFeature";
import { InrixVolumeTimePeriod } from "../controls/GetOrderItemInrixVolumeParams";

export const getInrixVolumeFeatureValue = (
  feature: InrixVolumeFeature,
  timePeriod: InrixVolumeTimePeriod,
  timeIndex: number | null,
): number | null => {
  if (timePeriod === InrixVolumeTimePeriod.ADT) {
    return feature.adt;
  }

  if (
    timeIndex === null ||
    timeIndex < 0 ||
    timeIndex >= feature.volumes.length
  ) {
    return null;
  }

  return feature.volumes[timeIndex];
};
